import React from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { ScrollableBody } from '../Layout/ScrollableBody';
import css from './PickupQRCode.module.scss';
import { VehicleReadyQRCode } from '../../controls/VehicleReadyQRCode/VehicleReadyQRCode';
import { useAppointmentStateUnsafe } from '../../context/Appointment/appointment';
import { Page } from '../Layout/Page/Page';

export const PickupQRCode: React.FC = () => {
    const appointment = useAppointmentStateUnsafe();
    const Localization = useLocalization();
    const { localization } = useKioskState();

    return (
        <Page
            suppressLocalizationButtons
            showKioskBanner={false}
            customHeaderProps={{
                title: Localization.ScanAtKiosk,
            }}
        >
            <ScrollableBody hideAccessibilityButton>
                <h2 className={css.title}>{Localization.ReadyForPickUpEnthusiastic}</h2>
                <p>{Localization.PleaseScanTheQRCode}</p>
                <br />
                {localization.location && (
                    <>
                        <h2 className={css.title}>{Localization.KioskLocation}</h2>
                        <p>{localization.location}</p>
                        <br />
                    </>
                )}
                <VehicleReadyQRCode appointmentKey={appointment?.key ?? ''} />
            </ScrollableBody>
        </Page>
    );
};
